import Svg from 'react-inlinesvg';

export default Svg;
